import React from "react";
import { Link } from "react-router-dom";
import ExternalLink from "./ExternalLink";
import { resumeFile, summary } from "../content";

function ResumePage() {
  return (
    <main id="content" className="resume-page" tabIndex={-1}>
      <div className="shell">
        <p className="eyebrow">Curriculum vitae</p>
        <h1>Resume</h1>
        <p className="lede">{summary.lead}</p>
        <p className="lede-quiet">{summary.support}</p>
        <p className="location">McKinney, TX · Open to Austin</p>
        <ul className="link-row">
          <li>
            <ExternalLink href={resumeFile}>Open PDF</ExternalLink>
          </li>
          <li>
            <ExternalLink href={resumeFile} download="Max_Kotas_Resume.pdf">
              Download
            </ExternalLink>
          </li>
          <li>
            <Link to="/">Back to work</Link>
          </li>
        </ul>
      </div>
    </main>
  );
}

export default ResumePage;
